import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { mapPublicCandidateJobDetail } from '@/modules/public-shortlist/mapPublicCandidate';
import { shortlistQueryKeys } from '@/modules/public-shortlist/queries/queryKeys';

export const usePublicJobCandidateDetailQuery = (
  candidateJobId: string,
  code: string,
) => {
  return useQuery({
    queryKey: shortlistQueryKeys.publicJobCandidateDetail(candidateJobId, code),
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        '/public/jobs/{code}/candidates/{candidateJobId}',
        {
          params: { path: { code, candidateJobId } },
        },
      );

      return data ? mapPublicCandidateJobDetail(data) : null;
    },
    enabled: Boolean(candidateJobId) && Boolean(code),
  });
};
